import { faEnvelope } from '@fortawesome/pro-regular-svg-icons';
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cx from 'classnames';
import {
    BZ2_GRID_WATCHDOG_FILTER_SAVED_WITH_unsubscribe,
    BZ2_GRID_WATCHDOG_SAVE_FILTER,
    BZ2_GRID_WATCHDOG_SAVE_FILTER_MESSAGE,
    BZ2_GRID_WATCHDOG_UNSUBSCRIBE,
} from 'mk/autogenerated/translations/Watchdog.e382eb9845c220b12f48115b99ac7cd2'
import { Btn,  BtnSidePadding, BtnType } from 'mk2/components/Btn';
import { Interpolate } from 'mk2/components/Interpolate';
import { Panel } from 'mk2/components/Panel';
import React from 'react';
import styles from './Watchdog.mscss';

interface OwnProps {
    className?: string;
    subscribed?: boolean;

    onSubscribe(event: React.MouseEvent<HTMLAnchorElement>);
    onUnsubscribe(event: React.MouseEvent<HTMLAnchorElement>);
}

type Props = OwnProps;

const Watchdog: React.FunctionComponent<Props> = ({ className, subscribed, onSubscribe, onUnsubscribe }) => (
    <Panel className={cx(styles.Watchdog, className)}>
        {subscribed ? (
            <>
                <FontAwesomeIcon className={styles.Watchdog__check} icon={faCheckCircle} />{' '}
                <Interpolate
                    i18nKey={BZ2_GRID_WATCHDOG_FILTER_SAVED_WITH_unsubscribe}
                    unsubscribe={
                        <Btn
                            className={styles.Watchdog__unsubscribe}
                            type={BtnType.Link}
                            onClick={onUnsubscribe}
                            label={BZ2_GRID_WATCHDOG_UNSUBSCRIBE}
                            sidePadding={BtnSidePadding.None}
                        />
                    }
                />
            </>
        ) : (
            <>
                <FontAwesomeIcon className={styles.Watchdog__envelope} icon={faEnvelope} size="2x" />{' '}
                <span dangerouslySetInnerHTML={{ __html: BZ2_GRID_WATCHDOG_SAVE_FILTER_MESSAGE }} />{' '}
                <Btn
                    className={styles.Watchdog__subscribe}
                    type={BtnType.Blue}
                    onClick={onSubscribe}
                    label={BZ2_GRID_WATCHDOG_SAVE_FILTER}
                />
            </>
        )}
    </Panel>
);

Watchdog.displayName = 'Watchdog';

export default React.memo<Props>(Watchdog);
